import React from "react";
import {
  Part1,
  Part1Text1,
  Part1Text2,
  Part2,
  Part22,
  Part2Text1,
  Part2Text2,
  RatingCont,
  RatingItem,
  RatingItem2,
  RatingItem3,
  RatingTextContainer,
  ScrollContainer2Section,
  Span1,
  Tag,
} from "./styles";
import { useNavigate } from "react-router-dom";

export const Ratings = () => {
  return (
    <>
      <RatingCont>
        <ScrollContainer2Section>
          <RatingItem3 $img={require("./item7.png")}>
            <Tag>Карьерная консультация</Tag>
            <RatingTextContainer>
              <Part1>
                <Part1Text1>
                  Я перехал и успешно нашёл работу. Спасибо!
                </Part1Text1>
                <Part1Text2>
                  {
                    "Привет! Мы обсуждали что я вернусь после переезда в Аргентину, и вот яперехал иуспешно нашёл работу Спасибо большое законсультации )"
                  }
                </Part1Text2>
              </Part1>
              <Part22>
                <Part2Text1>
                  <Span1>Игорь, </Span1>Business Analyst
                </Part2Text1>
                <Part2Text2 href={"https://linkedin.com"}>
                  Профиль LinkedIn →
                </Part2Text2>
              </Part22>
            </RatingTextContainer>
          </RatingItem3>
        </ScrollContainer2Section>

        <ScrollContainer2Section>
          <RatingItem3 $img={require("./item7.png")}>
            <Tag>Карьерная консультация</Tag>
            <RatingTextContainer>
              <Part1>
                <Part1Text1>
                  Я перехал и успешно нашёл работу. Спасибо!
                </Part1Text1>
                <Part1Text2>
                  {
                    "Привет! Мы обсуждали что я вернусь после переезда в Аргентину, и вот яперехал иуспешно нашёл работу Спасибо большое законсультации )"
                  }
                </Part1Text2>
              </Part1>
              <Part22>
                <Part2Text1>
                  <Span1>Игорь, </Span1>Business Analyst
                </Part2Text1>
                <Part2Text2 href={"https://linkedin.com"}>
                  Профиль LinkedIn →
                </Part2Text2>
              </Part22>
            </RatingTextContainer>
          </RatingItem3>
        </ScrollContainer2Section>

        <ScrollContainer2Section>
          <RatingItem3 $img={require("./item7.png")}>
            <Tag>Карьерная консультация</Tag>
            <RatingTextContainer>
              <Part1>
                <Part1Text1>
                  Я перехал и успешно нашёл работу. Спасибо!
                </Part1Text1>
                <Part1Text2>
                  {
                    "Привет! Мы обсуждали что я вернусь после переезда в Аргентину, и вот яперехал иуспешно нашёл работу Спасибо большое законсультации )"
                  }
                </Part1Text2>
              </Part1>
              <Part22>
                <Part2Text1>
                  <Span1>Игорь, </Span1>Business Analyst
                </Part2Text1>
                <Part2Text2 href={"https://linkedin.com"}>
                  Профиль LinkedIn →
                </Part2Text2>
              </Part22>
            </RatingTextContainer>
          </RatingItem3>
        </ScrollContainer2Section>

        <ScrollContainer2Section>
          <RatingItem2 $img={require("./item6.png")}>
            <Tag>Сопровождение Premium</Tag>
            <RatingTextContainer>
              <Part1>
                <Part1Text1>
                  Я шла за помощью в поиске работы, а получила намного больше.
                </Part1Text1>
                <Part1Text2>
                  Люба, большое спасибо!! Люба, ещё раз спасибо всей твоей
                  команде и тебе лично. Я была очень рада посотрудничать с
                  тобой. Во время поисков ты была сильной поддержкой, и это
                  помогало не сдаваться. Ты показала очень много инструментов
                </Part1Text2>
              </Part1>
              <Part2>
                <Part2Text1>
                  <Span1>Мария, </Span1>Junior UX
                </Part2Text1>
                <Part2Text2 href={"https://linkedin.com"}>
                  Профиль LinkedIn →
                </Part2Text2>
              </Part2>
            </RatingTextContainer>
          </RatingItem2>
        </ScrollContainer2Section>

        <ScrollContainer2Section>
          <RatingItem2 $img={require("./item6.png")}>
            <Tag>Сопровождение Premium</Tag>
            <RatingTextContainer>
              <Part1>
                <Part1Text1>
                  Я шла за помощью в поиске работы, а получила намного больше.
                </Part1Text1>
                <Part1Text2>
                  Люба, большое спасибо!! Люба, ещё раз спасибо всей твоей
                  команде и тебе лично. Я была очень рада посотрудничать с
                  тобой. Во время поисков ты была сильной поддержкой, и это
                  помогало не сдаваться. Ты показала очень много инструментов
                </Part1Text2>
              </Part1>
              <Part2>
                <Part2Text1>
                  <Span1>Мария, </Span1>Junior UX
                </Part2Text1>
                <Part2Text2 href={"https://linkedin.com"}>
                  Профиль LinkedIn →
                </Part2Text2>
              </Part2>
            </RatingTextContainer>
          </RatingItem2>
        </ScrollContainer2Section>

        <ScrollContainer2Section>
          <RatingItem2 $img={require("./item6.png")}>
            <Tag>Сопровождение Premium</Tag>
            <RatingTextContainer>
              <Part1>
                <Part1Text1>
                  Я шла за помощью в поиске работы, а получила намного больше.
                </Part1Text1>
                <Part1Text2>
                  Люба, большое спасибо!! Люба, ещё раз спасибо всей твоей
                  команде и тебе лично. Я была очень рада посотрудничать с
                  тобой. Во время поисков ты была сильной поддержкой, и это
                  помогало не сдаваться. Ты показала очень много инструментов
                </Part1Text2>
              </Part1>
              <Part2>
                <Part2Text1>
                  <Span1>Мария, </Span1>Junior UX
                </Part2Text1>
                <Part2Text2 href={"https://linkedin.com"}>
                  Профиль LinkedIn →
                </Part2Text2>
              </Part2>
            </RatingTextContainer>
          </RatingItem2>
        </ScrollContainer2Section>
      </RatingCont>
    </>
  );
};
